/* eslint-disable max-lines */
import React from "react";
import { useSelector } from "react-redux";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { MultiLineTextField } from "../../../components";
import { SubForm, SubFormNavigationProps } from "../../../components/SubForm";
import {
  pitchAboutYourselfInitialValues,
  pitchInputsMaxLength,
  usePitchInformationAboutYourselfValidationSchema,
} from "../../../helpers/formValidation";
import { useStrings } from "../../../localization/localizationHelpers";
import { getIsSavingForm } from "../../../redux/selectors";
import {
  PitchInformationFormId,
  PitchInformationSubFormsId,
} from "../PitchInformationPageConstants";
import * as styles from "../PublisherDeveloperSubForm/PublisherDeveloperSubForm.module.css";

const AboutYourselfSubForm = (props: SubFormNavigationProps) => {
  const [
    pitchAboutYourselfTellUsMoreAboutYourselfTitle,
    pitchAboutYourselfTellUsMoreAboutYourselfSubtitle,
    pitchAboutYourselfAreYouActiveInTheLocalGameDevTitle,
  ] = useStrings(
    "pitchAboutYourselfTellUsMoreAboutYourselfTitle",
    "pitchAboutYourselfTellUsMoreAboutYourselfSubtitle",
    "pitchAboutYourselfAreYouActiveInTheLocalGameDevTitle"
  );

  const validationSchema = usePitchInformationAboutYourselfValidationSchema();
  const isSavingFormToCrm = useSelector(getIsSavingForm);

  return (
    <SubForm
      validateConfig={validationSchema}
      initialValues={pitchAboutYourselfInitialValues}
      formId={PitchInformationFormId}
      subFormId={PitchInformationSubFormsId.AboutYourself}
      {...props}
    >
      <Row className={styles.container}>
        <Column>
          <MultiLineTextField
            name="studioBackground"
            title={pitchAboutYourselfTellUsMoreAboutYourselfTitle}
            subtitle={pitchAboutYourselfTellUsMoreAboutYourselfSubtitle}
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <MultiLineTextField
            name="activeInLocalGameDev"
            title={pitchAboutYourselfAreYouActiveInTheLocalGameDevTitle}
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
        </Column>
      </Row>
    </SubForm>
  );
};

export default AboutYourselfSubForm;
